import { Button } from '@cian/ui-kit';
import { IconFileEdit16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

export interface INoteButtonProps {
  onClick(): void;
  entityId: number;
}

export class NoteButton extends React.PureComponent<INoteButtonProps> {
  public render() {
    const { onClick } = this.props;

    return (
      <div>
        <Button
          size="XS"
          theme="fill_secondary"
          onClick={onClick}
          title="Оставить заметку к объявлению (видно только вам)"
          beforeIcon={<IconFileEdit16 color="icon-main-default" />}
          data-testid="NoteButton"
        />
      </div>
    );
  }
}
